<template>
  <div
    id="todo-app"
    class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
  >
    <vs-sidebar
      class="items-no-padding"
      parent="#todo-app"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isSidebarActive"
    >
      <div class="header-sidebar" slot="header">
        <vs-avatar size="70px" :src="bookingLogo" />
        <span>{{$store.state.AppActiveUser.email}}</span>
        <h4>Booking List</h4>
      </div>
      <div class="booking-content-scroll-area">
        <vs-sidebar-item
          @click="showDisplayPrompt(booking)"
          v-for="booking in bookings"
          :key="booking.id"
          :index="booking.id"
          icon="question_answer"
        >
          {{booking.api_booking_id}}
          <br />
          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="8"
            >{{booking.status == 'active'? ' locating a ride...': booking.status}}</vs-col>
          </vs-row>
        </vs-sidebar-item>
      </div>
      <!-- <component
        :is="scrollbarTag"
        class="todo-scroll-area"
        :settings="settings"
        :key="$vs.rtl"
      >
        <transition-group
          @closeSidebar="toggleTodoSidebar"
          class="todo-list"
          name="list-enter-up"
          tag="ul"
          appear
        >
          <li
            class="cursor-pointer todo_todo-item"
            v-for="(booking, index) in bookings"
            :key="String(booking.id)"
            :style="[{transitionDelay: (index * 0.1) + 's'}]"
          >
            <booking-row
              :booking="booking"
              @showDisplayPrompt="showDisplayPrompt($event)"
              :key="String(booking.id) + String(booking.status)"
            />
          </li>
        </transition-group>
      </component>-->
      <div class="footer-sidebar" slot="footer">
        <vs-button
          @click="logout"
          class="cursor-pointer hover:bg-primary hover:text-white"
          color="danger"
          type="gradient"
          icon-pack="feather"
          icon="icon-log-out"
        >Logout</vs-button>
      </div>
    </vs-sidebar>
    <div
      :class="{'sidebar-spacer': clickNotClose}"
      class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content"
    >
      <div
        class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light"
      >
        <!-- TOGGLE SIDEBAR BUTTON -->
        <feather-icon
          class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer"
          icon="MenuIcon"
          @click.stop="toggleTodoSidebar(true)"
        />
      </div>

      <!-- TODO LIST -->
      <component
        ref="taskListPS"
        :is="scrollbarTag"
        class="todo-content-scroll-area"
        :settings="settings"
        :key="$vs.rtl"
      >
        <vx-card title="Venue Details" class>
          <gmap-map ref="gmap" :center="center" :zoom="15" class="map-cls">
            <gmap-marker :position="position"></gmap-marker>
          </gmap-map>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 float-left">
            <vs-row class="mt-4">
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6" class="cust-width">
                <gmap-autocomplete
                  ref="autocomplete"
                  class="vs-inputx vs-input--input large"
                  @place_changed="setPlace"
                  placeholder="Destination / Optional"
                ></gmap-autocomplete>
              </vs-col>
            </vs-row>
            <vs-row class="mt-2">
              <vs-col>
                <vs-input
                  size="large"
                  label-placeholder="Customer Name"
                  v-model="customer.name"
                  v-validate="{ required: payByCard }"
                  name="name"
                  class="cust-width"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('name')"
                >{{ errors.first('name') }}</span>
              </vs-col>
            </vs-row>

            <vs-row class="mt-2">
              <vs-col>
                <vs-input
                  size="large"
                  v-validate.continues="'cust-telephone'"
                  name="telephone"
                  label-placeholder="Customer Telephone"
                  v-model="customer.telephone"
                  type="number"
                  class="cust-width"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('telephone')"
                >{{ errors.first('telephone') }}</span>
              </vs-col>
            </vs-row>

            <vs-row class="mt-6">
              <vs-col vs-type="flex" vs-justify="flex-start" vs-w="6">
                <vs-checkbox v-model="payByCard">Pay By Card</vs-checkbox>
              </vs-col>
            </vs-row>
          </div>

          <div class="ml-auto mt-4 vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <table class="mt-20">
              <tr class="h-150">
                <td>
                  <div>Quote</div>
                </td>
                <td class="w-300">
                  <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                      <h1>
                        £
                        {{customer.quotePrice ? customer.quotePrice: 0}}
                      </h1>
                    </vs-col>
                  </vs-row>
                </td>
                <td>
                  <h4 class="mr-auto">{{customer.distance}}</h4>
                </td>
              </tr>
              <tr>
                <td vs-align="right" vs-type="flex" vs-justify="right" vs-w="8"></td>
                <td vs-align="right" vs-type="flex" vs-justify="right" vs-w="8"></td>
                <td>
                  <vs-button
                    icon-pack="feather"
                    icon="icon-car"
                    size="large"
                    @click="bookNow"
                  >Book Now</vs-button>
                </td>
              </tr>
            </table>
          </div>
        </vx-card>
        <!-- </transition-group> -->
      </component>
      <!-- /TODO LIST -->
    </div>

    <!-- BOOKING DETAIL DIALOG -->
    <booking-detail-prompt
      :displayPrompt="displayPrompt"
      :booking="bookingToShow"
      @hideDisplayPrompt="hidePrompt"
      v-if="displayPrompt"
    ></booking-detail-prompt>
  </div>
</template>
<script>
import { _createQuote, _createBooking, _list } from "@/services/Booking.js";
import { Validator } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import BookingDetailPrompt from "./booking/BookingDetail";
import BookingRow from "./booking/BookingRow";

const dict = {
  custom: {
    name: {
      required: "Customer name is required",
    },
    telephone: {
      required: "Customer number is required",
    },
  },
};
// register custom messages
Validator.localize("en", dict);
export default {
  name: "BasicUserDashboard",
  components: {
    VuePerfectScrollbar,
    BookingDetailPrompt,
    BookingRow,
  },
  data() {
    return {
      payByCard: false,
      active: false,
      clickNotClose: true,
      isSidebarActive: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      position: {
        lat: parseFloat(this.$store.state.venue.latitude),
        lng: parseFloat(this.$store.state.venue.longitude),
      },
      center: {
        lat: parseFloat(this.$store.state.venue.latitude),
        lng: parseFloat(this.$store.state.venue.longitude),
      },
      venue: this.$store.state.venue,
      customer: {
        name: "",
        telephone: "",
        quotePrice: null,
        distance: "",
      },
      destinationPlace: "",
      bookingLogo: require("@/assets/images/logo/logo.png"),
      bookings: [],
      bookingToShow: {},
      displayPrompt: false,
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  mounted() {
    if (localStorage.getItem("role") == "user") {
      this.getBookings();
      this.active = true;
    }
  },

  watch: {
    payByCard: {
      handler: function (val, oldVal) {
        if (!val) {
          this.errors.clear(); // call it in the context of your component object
        } else {
          this.errors.add({
            field: "telephone",
            msg: "The telephone must start with 07",
          });
        }
      },
      deep: true,
    },
    // todoFilter() {
    //   const scroll_el = this.$refs.taskListPS.$el || this.$refs.taskListPS
    //   scroll_el.scrollTop = 0

    //   this.toggleTodoSidebar()

    //   // Fetch Tasks
    //   let filter = this.$route.params.filter
    //   this.$store.dispatch("todo/fetchTasks", { filter: filter })
    //   this.$store.commit("todo/UPDATE_TODO_FILTER", filter)
    // },
    windowWidth() {
      this.setSidebarWidth();
    },
  },
  created() {
    this.setSidebarWidth();

    this.$validator.extend("cust-telephone", {
      getMessage: (field) => "The " + field + " must start with 07",
      validate: (value) => {
        var strongRegex = new RegExp("^(07)([0-9]*)$");
        var val = strongRegex.test(value);
        if (this.payByCard == true) {
          if (val == true) {
            return true;
          }
          return false;
        }
        return true;
      },
    });

    //  this.$nextTick(function () {
    //         window.setInterval(() => {
    //             this.getBookings();
    //         },5000);
    //     })
    // this.interval = setInterval(() => this.getBookings, 1000);
  },
  beforeCreate() {
   if (localStorage.getItem("role") != "user")
      this.$router.push("/pages/not-authorized");
  },
  methods: {
    getBookings() {
      _list()
        .then((response) => {
          this.bookings = response.data.obj.list;
        })
        .catch((error) => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },

    showDisplayPrompt(item) {
      this.bookingToShow = item;
      this.displayPrompt = true;
    },
    hidePrompt() {
      this.displayPrompt = false;
    },
    logout() {
      this.active = false;
      this.$store.dispatch("auth/doLogout").then(() => {
        if (localStorage.getItem("accessToken"))
          localStorage.removeItem("accessToken");
        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change("admin");
        localStorage.removeItem("userInfo");
        this.$router.push("/login").catch(() => {});
      });
    },
    setPlace(place) {
      this.$vs.loading({
        text: "Fetching quote price",
      });
      this.destinationPlace = place;
      this.getQuote();
    },
    getQuote() {
      let data = {
        destination: {
          lat: this.destinationPlace.geometry.location.lat(),
          lng: this.destinationPlace.geometry.location.lng(),
        },
        pickup: {
          lat: parseFloat(this.venue.latitude),
          lng: parseFloat(this.venue.longitude),
        },
        pickupDueTime: new Date(),
      };
      _createQuote(data)
        .then((response) => {
          this.$vs.loading.close();
          let localResponse = response.data.obj;

          this.customer.quotePrice = localResponse.outward.price;
          this.customer.distance =
            localResponse.outward.distance +
            " " +
            localResponse.outward.measurement;
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    bookNow() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading({
            text: "Please wait",
          });
          let data = {
            venueId: this.venue.id,
            companyApiId: this.$store.state.company.apiID,
            customer: this.customer,
            pickupDueTime: new Date(),
            destination: {
              _text: this.destinationPlace
                ? this.destinationPlace.formatted_address
                : null,
              lat: this.destinationPlace
                ? this.destinationPlace.geometry.location.lat()
                : null,
              lng: this.destinationPlace
                ? this.destinationPlace.geometry.location.lng()
                : null,
              placeId: this.destinationPlace
                ? this.destinationPlace.place_id
                : null,
            },
            pickup: {
              _text: this.venue.street,
              lat: parseFloat(this.venue.latitude),
              lng: parseFloat(this.venue.longitude),
            },
          };
          _createBooking(data)
            .then((response) => {
              this.$vs.loading.close();
              this.customer = {};
              this.payByCard = false;
              this.destinationPlace = null;
              this.bookings.push(response.data.obj.booking);
              this.$refs.autocomplete.$refs.input.value = "";
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: error.response.data.responseTitle,
                text: error.response.data.responseMessage,
                iconPack: "feather",
                icon: "icon-cross-circle",
                color: "danger",
              });
            });
        } else {
        }
      });
    },

    // detail(booking) {
    //   this.bookingToShow = booking;
    //   this.displayPrompt = true;
    // },
    clearFields() {
      this.bookingToShow = {};
    },
    cancelBooking() {
      alert("hi");
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isSidebarActive = this.clickNotClose = false;
      } else {
        this.isSidebarActive = this.clickNotClose = true;
      }
    },
    toggleTodoSidebar(value = false) {
      if (!value && this.clickNotClose) return;
      this.isSidebarActive = value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/apps/todo.scss";

.no-scroll-content {
  height: calc(var(--vh, 1vh) * 100 - 0.5rem) !important;
}

#todo-app .todo-scroll-area {
  position: relative;
  width: 100%;
  height: calc(100%) !important ;
}
.cust-width {
  width: 242px !important;
}
</style>
